import React from "react";

const AddScheduleModal = () => {
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="beheereenheid_toevoegen_modal"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Nieuw Beheereenheid</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <label>Naam beheereenheid *</label>
            <input
              id="beheereenheid_naam"
              type="input"
              className="form-control"
              placeholder="Naam beheereenheid"
            />
            <label>Code</label>
            <input
              id="beheereenheid_code"
              type="input"
              className="form-control"
              placeholder="Code"
            />
            <label>Horizon Begin</label>
            <input
              id="beheereenheid_begin"
              type="datetime-local"
              className="form-control"
              placeholder="Horizon Begin"
            />
            <label>Horizon Einde</label>
            <input
              id="beheereenheid_end"
              type="datetime-local"
              className="form-control"
              placeholder="Horizon Einde"
            />
            <div>
              <br />
              <input
                type="checkbox"
                id="beheereenheid_active"
                name="is_active"
                defaultChecked
              />
              <label htmlfor="is_active"> &nbsp; Actief</label>

              <br />
              <br />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" id="save_beheereenheid" className="btn-modal">
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddScheduleModal;
